import throttle from 'lodash/throttle'

const events = {
  online: 'appOnline',
  redirect: 'appRedirect',
  notifications: { token: 'appNotificationToken', message: 'appNotification' }
}

let vue = null

export default {
  events,

  startListeners: function (vi) {
    vue = vi
    document.addEventListener(events.redirect, this.handleRedirect, false)
    document.addEventListener(events.notifications.token, this.handleNotificationToken, false)
    document.addEventListener(events.notifications.message, this.handleNotification, false)
  },

  stopListeners: function () {
    document.removeEventListener(events.redirect)
    document.removeEventListener(events.notifications.token)
    document.removeEventListener(events.notifications.message)
  },

  handleRedirect: function (event) {
    if (event && event.detail && event.detail.path) {
      vue.$router.push({ path: event.detail.path })
    }
  },

  handleNotificationToken: throttle(function (event) {
    vue.$store.dispatch('savePushNotificationToken', event.detail.token)
  }, 2000, { leading: true, trailing: false }),

  handleNotification: function (event) {
    const notification = event.detail

    const deepLink = notification.deepLink.replace(vue.$webRoot, '')

    if (notification.tapped) {
      if (deepLink) {
        vue.$router.push({ path: deepLink })
      }
    } else {
      const stamp = new Date().getTime()
      const key = `push-${stamp}`

      const internalNotification = {
        key,
        title: notification.title,
        message: notification.body,
        deepLink: deepLink
      }

      vue.$store.dispatch('addNotification', internalNotification)
    }
  }
}
